"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAuthSwapProvider = exports.createAuthProvider = exports.useAccessTokenCallback = exports.useAuthClientLogin = exports.useUserProfile = exports.useAuthState = void 0;
var react_provision_1 = require("@newfront-insurance/react-provision");
var react_1 = require("react");
var keycloak_1 = require("../clients/keycloak");
var session_storage_1 = require("../clients/persistors/session-storage");
var jwt_1 = require("../internal/helpers/jwt");
/**
 * Subscribe to the auth state on an AuthClient
 * @param client AuthClient
 * @returns AuthState
 */
function useAuthState(client) {
    var _a = (0, react_1.useState)(function () { return client.getAuthState(); }), authState = _a[0], setAuthState = _a[1];
    (0, react_1.useEffect)(function () {
        var unsub = client.subscribe(function (newState) { return setAuthState(newState); });
        return function () {
            unsub();
        };
    }, [client]);
    return authState;
}
exports.useAuthState = useAuthState;
/**
 * Get the user profile from the auth state on the auth client.
 * @param tokens The state from the AuthClient
 * @returns UserProfile
 */
function useUserProfile(tokens) {
    var idToken = tokens.idToken, token = tokens.token;
    return (0, react_1.useMemo)(function () {
        var _a, _b, _c;
        if (!token || !idToken) {
            return undefined;
        }
        var parsedToken = (0, jwt_1.parseTokenPayload)(token);
        var parsedIdToken = (0, jwt_1.parseTokenPayload)(idToken);
        var scopes = (_b = (_a = parsedToken.scope) === null || _a === void 0 ? void 0 : _a.split(' ')) !== null && _b !== void 0 ? _b : [];
        return {
            uuid: parsedIdToken.userId,
            email: parsedIdToken.email,
            profilePic: parsedIdToken.profilePic,
            roles: scopes,
            scopes: scopes,
            firstName: parsedIdToken.given_name,
            lastName: parsedIdToken.family_name,
            accounts: (_c = parsedToken.newfront_accounts) !== null && _c !== void 0 ? _c : [],
        };
    }, [idToken, token]);
}
exports.useUserProfile = useUserProfile;
/**
 * Login using the client.
 * @param client AuthClient
 */
function useAuthClientLogin(client) {
    var _a = (0, react_1.useState)(), error = _a[0], setError = _a[1];
    var _b = useAuthState(client), isReady = _b.isReady, isLoggedIn = _b.isLoggedIn;
    // Start the auth client
    (0, react_1.useEffect)(function () {
        if (!isReady) {
            client.start().catch(function (e) {
                setError(e);
            });
        }
    }, [isReady, client]);
    // Login when ready
    (0, react_1.useEffect)(function () {
        if (isReady && !isLoggedIn) {
            client.login().catch(function (e) {
                setError(e);
            });
        }
    }, [isLoggedIn, isReady, client]);
    if (error) {
        throw error;
    }
}
exports.useAuthClientLogin = useAuthClientLogin;
/**
 * Returns a function that can be used to get an updated auth token that can be used
 * to make requests. This should be called before every request.
 * @param client AuthClient
 * @returns
 */
function useAccessTokenCallback(client) {
    var _this = this;
    return (0, react_1.useCallback)(function () { return __awaiter(_this, void 0, void 0, function () {
        var tokens;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.updateTokens()];
                case 1:
                    tokens = _a.sent();
                    return [2 /*return*/, tokens === null || tokens === void 0 ? void 0 : tokens.token];
            }
        });
    }); }, [client]);
}
exports.useAccessTokenCallback = useAccessTokenCallback;
/**
 * Returns an async callback that will swap the current token for a another token
 * for a different client id.
 */
function useSwapTokenProvider(authClient, clientId, isEnabled) {
    var _this = this;
    if (isEnabled === void 0) { isEnabled = true; }
    var authState = useAuthState(authClient);
    var _a = (0, react_1.useState)(), token = _a[0], setToken = _a[1];
    var _b = (0, react_1.useState)(), scopes = _b[0], setScopes = _b[1];
    var _c = (0, react_1.useState)(), swapContext = _c[0], setSwapContext = _c[1];
    var userDetails = useUserProfile({ idToken: authState.idToken, token: token });
    /**
     * Whenever the cached token changes the scopes will be updated.
     */
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (!token) {
            setScopes(undefined);
        }
        else {
            var parsedToken = (0, jwt_1.parseTokenPayload)(token);
            setScopes((_b = (_a = parsedToken.scope) === null || _a === void 0 ? void 0 : _a.split(' ')) !== null && _b !== void 0 ? _b : []);
        }
    }, [token]);
    /**
     * Whenever the swap context changes we need to reset the token and the
     * scopes so they aren't used for the new context.
     */
    (0, react_1.useEffect)(function () {
        setScopes(undefined);
        setToken(undefined);
        if (authState.isLoggedIn && isEnabled && (swapContext === null || swapContext === void 0 ? void 0 : swapContext.newfrontAccountUuid)) {
            authClient
                .swap(clientId, swapContext)
                .then(function (_a) {
                var token = _a.token;
                setToken(token);
            })
                .catch(function (error) {
                throw error;
            });
        }
    }, [authClient, clientId, swapContext, authState.isLoggedIn, isEnabled]);
    /**
     * This is an async function that returns the current token. If the token
     * is expired it will reload it otherwise it will skip the HTTP request
     * and return the cached token.
     */
    var getSwappedAccessToken = (0, react_1.useCallback)(function () { return __awaiter(_this, void 0, void 0, function () {
        var swappedTokens;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // There's no context selected, so the token is always null
                    if (!swapContext) {
                        return [2 /*return*/, undefined];
                    }
                    if (!(!token || (0, jwt_1.isTokenExpired)(token))) return [3 /*break*/, 2];
                    return [4 /*yield*/, authClient.swap(clientId, swapContext)];
                case 1:
                    swappedTokens = _a.sent();
                    setToken(swappedTokens.token);
                    return [2 /*return*/, swappedTokens.token];
                case 2: 
                // Return the cached token
                return [2 /*return*/, token];
            }
        });
    }); }, [authClient, clientId, swapContext, token]);
    return {
        getSwappedAccessToken: getSwappedAccessToken,
        getToken: getSwappedAccessToken,
        scopes: scopes,
        swapContext: swapContext,
        setSwapContext: setSwapContext,
        userDetails: userDetails,
    };
}
/**
 * Create the KeycloakAuthClient that will be used to manage the JWT token.
 */
function useKeycloakAuthClient(options) {
    var authApiConfig = options.authApiConfig, idpHint = options.idpHint, redirectUri = options.redirectUri;
    var clientId = authApiConfig.clientId, realm = authApiConfig.realm, url = authApiConfig.url;
    return (0, react_1.useMemo)(function () {
        return new keycloak_1.KeycloakAuthClient({
            config: {
                clientId: clientId,
                realm: realm,
                url: url,
            },
            initOptions: {
                pkceMethod: 'S256',
            },
            loginOptions: {
                idpHint: idpHint,
                redirectUri: redirectUri,
            },
            tokenPersistor: new session_storage_1.SessionStoragePersistor("kcToken-".concat(realm, "-").concat(clientId)),
        });
    }, [clientId, idpHint, realm, redirectUri, url]);
}
var createAuthProvider = function (props) {
    var authApiConfig = props.authApiConfig;
    var clientId = authApiConfig.clientId, realm = authApiConfig.realm;
    return (0, react_provision_1.createProvider)(function () {
        var client = useKeycloakAuthClient(props);
        var authState = useAuthState(client);
        var userDetails = useUserProfile(authState);
        var logout = (0, react_1.useCallback)(function (redirectUrl) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, client.logout(redirectUrl)];
        }); }); }, [client]);
        var getAccessTokenCallback = useAccessTokenCallback(client);
        return {
            getAccessTokenCallback: getAccessTokenCallback,
            getToken: getAccessTokenCallback,
            logout: logout,
            userDetails: userDetails,
            authState: authState,
            client: client,
        };
    }, {
        name: "AuthProvider-".concat(realm, "-").concat(clientId),
    });
};
exports.createAuthProvider = createAuthProvider;
function createAuthSwapProvider(options) {
    var authProvider = options.authProvider, clientId = options.clientId, _a = options.isEnabled, isEnabled = _a === void 0 ? true : _a;
    return (0, react_provision_1.createProvider)(function () {
        var client = (0, react_provision_1.useProvider)(authProvider).client;
        return useSwapTokenProvider(client, clientId, isEnabled);
    });
}
exports.createAuthSwapProvider = createAuthSwapProvider;
